import { render } from "./fontsRubin.vue?vue&type=template&id=69e72fb0"
const script = {}

import "./fontsRubin.vue?vue&type=style&index=0&id=69e72fb0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__